import { useAuthStore } from '../../../stores/authStore';
import { DirectoryListingCard } from '../../../components/settings/DirectoryListingCard';
import { SettingsSubPage } from '../components/SettingsSubPage';

export function DirectoryListingPage() {
  const authBusiness = useAuthStore(s => s.business);

  return (
    <SettingsSubPage title="Directory listing" description="Appear on CrewBit Explore, cover photo">
      {authBusiness?.id && (
        <DirectoryListingCard businessId={authBusiness.id} tier={authBusiness.tier} />
      )}
    </SettingsSubPage>
  );
}
